module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-7-e9ca427e5072c09a413c90a6609e0d6f.webp";